import userIcon from '../assets/icons/user.png';
import placeIcon from '../assets/icons/place.png';
import polePositionIcon from '../assets/icons/poleposition.png';
import reservaIcon from '../assets/icons/reserva.png';
import enterpriseIcon from '../assets/icons/enterprise.png';
import gestaoIcon from '../assets/icons/gesao_de_reserva.png';
import arrowIcon from '../assets/icons/arrow-rigth.png';
import exitIcon from '../assets/icons/exit.png';
import editIcon from '../assets/icons/edit.png';
import checkIcon from '../assets/icons/checked.png';
import unCheckIcon from '../assets/icons/unCheck.png';
import pingIcon from '../assets/icons/ping.png';
import poleIcon from '../assets/icons/pole.png';
import newPoleIcon from '../assets/icons/newPole.png';
import checkRoundIcon from '../assets/icons/checkRound.png';
import unCheckRoundIcon from '../assets/icons/unCheckRound.png';
import libraryIcon from '../assets/icons/library.png';
import pingGrenIcon from '../assets/icons/pingGren.png';
import pingGreyIcon from '../assets/icons/pingGrey.png';
import arrowLeftBlueIcon from '../assets/icons/arrowLeft.png';
import libraryPhotoIcon from '../assets/icons/libraryPhoto.png';
import folderIcon from '../assets/icons/folder.png';
import benefitIcon from '../assets/icons/benefit.png';
import checkIconPing from '../assets/icons/check.png';
import trashIcon from '../assets/icons/trash.png';
import plusGreenIcon from '../assets/icons/plusGrenn.png';
import pinIcon from '../assets/icons/pin.png';
import discretionIcon from '../assets/icons/discretion.png';
import checkEndIcon from '../assets/icons/chekEnd.png';
import noteIcon from '../assets/icons/note.png';
import viewIcon from '../assets/icons/view.png';

export default {
  viewIcon,
  noteIcon,
  discretionIcon,
  checkEndIcon,
  pinIcon,
  checkIconPing,
  plusGreenIcon,
  trashIcon,
  benefitIcon,
  libraryPhotoIcon,
  folderIcon,
  arrowLeftBlueIcon,
  userIcon,
  placeIco: placeIcon,
  polePositionIcon,
  reservaIcon,
  enterpriseIcon,
  gestaoIcon,
  arrowIcon,
  exitIcon,
  editIcon,
  checkIcon,
  unCheckIcon,
  pingIcon,
  poleIcon,
  newPoleIcon,
  checkRoundIcon,
  unCheckRoundIcon,
  libraryIcon,
  pingGrenIcon,
  pingGreyIcon,
};
